<section class="mb-12" [class.hidden]="!resources().length">
    <span class="text-headline-medium mb-8 flex justify-center" [class.mt-12]="isLast()">
        {{ firstCategory()?.translations_refs | getTranslation: "name" }}
    </span>
    <div class="flex flex-wrap justify-around gap-8 gap-y-12">
        @for (resource of resources(); track resource) {
            <div
                class="card-shadow flex max-h-78.5 min-h-78.5 max-w-50 min-w-50 flex-col items-center justify-center gap-4 rounded-lg p-4 md:max-h-100 md:min-h-100 md:max-w-75 md:min-w-75 lg:max-h-132 lg:min-h-132 lg:max-w-83.5 lg:min-w-83.5"
            >
                <figure>
                    @if (resource?.image) {
                        <img
                            [ngSrc]="resource?.image | getDirectusImage"
                            width="300"
                            height="400"
                            [alt]="resource?.translations_refs | getTranslation: 'name'"
                            class="max-h-47 min-h-47 max-w-45 min-w-45 object-contain md:max-h-75 md:min-h-75 md:max-w-70 md:min-w-70 lg:max-h-100 lg:min-h-100 lg:max-w-75 lg:min-w-75"
                        />
                    }
                    <figcaption class="text-center">
                        <span class="text-body-small text-neutral-20">
                            {{ resource?.translations_refs | getTranslation: "name" }}
                        </span>
                    </figcaption>
                </figure>
                @switch (resource?.type) {
                    @case ("file") {
                        <a
                            [href]="resource.file_ref | getDirectusFile"
                            target="_blank"
                            class="border-primary hover:bg-primary-98 text-body-small text-primary flex w-full cursor-pointer items-center justify-center gap-3 rounded-md border bg-white px-4 py-2 text-center"
                        >
                            <svg-icon
                                [svgStyle]="{ width: '20px', height: '20px' }"
                                src="assets/icons/Download-Bottom.svg"
                            />
                            <span class="hidden lg:block">
                                {{ "resource_block.download_pdf" | transloco }}
                                {{ resource?.file_ref | fileSize }}
                            </span>
                            <span class="block lg:hidden">
                                {{ "resource_block.mobile_download_pdf" | transloco }}
                                {{ resource?.file_ref | fileSize }}
                            </span>
                        </a>
                    }
                    @case ("external") {
                        <a
                            [href]="resource?.url"
                            target="_blank"
                            class="border-primary hover:bg-primary-98 text-body-small text-primary flex w-full cursor-pointer items-center justify-center gap-3 rounded-md border bg-white px-4 py-2 text-center"
                        >
                            <svg-icon
                                [svgStyle]="{ width: '20px', height: '20px' }"
                                src="assets/icons/Share-External-Link-1.svg"
                            />
                            <span class="hidden lg:block">
                                {{ "resource_block.access_link" | transloco }}
                            </span>
                            <span class="block lg:hidden">
                                {{ "resource_block.mobile_access_link" | transloco }}
                            </span>
                        </a>
                    }
                }
            </div>
        }
    </div>
</section>
